import { Injectable } from '@angular/core';
import {
    Job,
    JobUpdate,
    JobWithAssessments,
    JobWithEverything
} from '../core-data-model/Job.model';
import { ContextDataService } from '../core-services/Context.dataservice';
import { DataStore } from '../core-services/DataStore/DataStore';
import { JobApi } from '../core-services/JobApi/JobApi.connect';
import { JobsDataService } from '../core-services/Jobs.dataservice';

export enum JobHydration {
    AddAssessments = 1,
    AddAssessmentsAndRoleModels = 2
}

@Injectable({
    providedIn: 'root'
})
export class StoreDataService {
    jobs: DataStore<Job, JobUpdate, JobWithAssessments>;

    constructor(
        private jobApi: JobApi,
        private jobsDataService: JobsDataService,
        public context: ContextDataService
    ) {
        this.jobs = new DataStore<Job, JobUpdate, JobWithAssessments>({
            get: async (id) => {
                const job = await this.jobApi.getJob(id);
                this.context.job = job;
                return job;
            },
            delete: (id) => {
                this.jobsDataService.jobBeingArchived(id);
                return this.jobApi.archive(id);
            },
            patch: (update) => this.jobApi.updateJob(update),
            post: (update) => this.jobApi.createJob(update),
            hydrate: async (job, level) => {
                const assessments = await this.jobApi.getJobAssessmentsForJob(
                    job.id
                );
                if (level === JobHydration.AddAssessments) {
                    return new JobWithAssessments(
                        Object.assign({}, job, {
                            assesssments: assessments
                        })
                    );
                } else if (level === JobHydration.AddAssessmentsAndRoleModels) {
                    const [assessmentsResult, roleModels] = await Promise.all([
                        this.jobApi.getJobAssessmentsForJob(job.id),
                        this.jobApi.getJobRoleModels(job.id)
                    ]);
                    return new JobWithEverything(
                        Object.assign({}, job, {
                            assessments: assessmentsResult,
                            roleModels: roleModels
                        })
                    );
                }
            }
        });
    }
}
